<div class="ribbon p-12px fixed-bottom text-center bg-danger text-white" *ngIf="visible">
  <p class="m-0 pr-6">{{ environmentName }}</p>
</div>
